import { routes } from '@t2/client-base'
import { recoil } from '@t2/client-recoil'
import { useRedirect } from '@t2/frontend-common'
import { useEffect } from 'react'

const Page = () => {
  // TODO: トップページはどうするか？
  //       いったん、searchにリダイレクトしている
  const redirect = useRedirect()
  const ability = recoil.useAbility()

  useEffect(() => {
    if (ability.can('query-records')) {
      redirect(routes.searchPath())
    } else {
      redirect(routes.annotationTasksPath())
    }
  }, [])

  return <div></div>
}

export default Page
